import config from '../config';
import axios from 'axios';

export const uploadService = {
    uploadImage,    
};

//-- It's common function for using the token
function uploadImage(apiName, data) {
    // console.log("asdsadsadasdasdHERE", apiName)
    
    let tokenObj = JSON.parse(sessionStorage.getItem("token"));
    return axios({
            method: 'POST',
            url: `${config.apiUrl+apiName}`,
            headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenObj },
            data: data
        }).then((response) => {
            return response;
        }).catch((error) => {
             return error;
        });
  

}; 